/**
 * Shopify Label Designer
 * Drop-in integration for the YTimes Label Designer system on Shopify stores.
 *
 * Requires: jQuery (loaded by this script if not present)
 * Requires: A Custom Liquid block on the product page that renders #ytimesLabelDesigner
 *           with data-label-id, data-product-id, data-variant-id attributes.
 *
 * Adapted from ytimes-label-designer-2024.js (Yahoo/Turbify version).
 */

(function() {
  "use strict";

  var ldMainUrl = "https://labeldesigner.executivegiftsblog.com/labelDesigner/";

  // --- Ensure jQuery is available -------------------------------------------
  function ensureJQuery(callback) {
    if (typeof jQuery !== "undefined") {
      callback();
    } else {
      var s = document.createElement("script");
      s.src = "https://code.jquery.com/jquery-3.7.1.min.js";
      s.onload = callback;
      document.head.appendChild(s);
    }
  }

  // --- Main Init ------------------------------------------------------------
  ensureJQuery(function() {
    jQuery(document).ready(function() {
      var $mount = jQuery("#ytimesLabelDesigner");
      if ($mount.length === 0) return; // No mount point = no personalization for this product

      var labelDesignerId = $mount.attr("data-label-id");
      if (!labelDesignerId) return;

      var shopifyProductId = $mount.attr("data-product-id");
      var shopifyVariantId = $mount.attr("data-variant-id");
      // Logo readiness: check the data attribute first, then fall back to
      // the global isLogoReady variable that the PHP backend template may set.
      // Defaults to false — must be explicitly enabled per product.
      var isLogoReady = (function() {
        var attr = $mount.attr("data-logo-ready");
        if (attr === "true") return true;
        if (attr === "false") return false;
        // Fall back to global variable (may be set by PHP template HTML)
        if (typeof window.isLogoReady !== "undefined") return !!window.isLogoReady;
        return false;
      })();

      // Detect iOS
      var iosrd = /iPod|iPhone|iPad/.test(navigator.userAgent);

      // --- Shopify DOM References -------------------------------------
      var $productForm = jQuery('form[action*="/cart/add"]').first();
      var $addToCartBtn = $productForm.find("button.add-to-cart-button").first();
      var $quantityInput = $productForm.find('input[name="quantity"]').first();
      var $buyButtonsBlock = $productForm.closest(".buy-buttons-block");

      // If we can't find the form, bail
      if ($productForm.length === 0) {
        console.warn("[LabelDesigner] Could not find Shopify product form.");
        return;
      }

      // --- Load Dependencies ------------------------------------------
      // jQuery UI (for draggable preview)
      var juiScript = document.createElement("script");
      juiScript.src = "https://code.jquery.com/ui/1.13.2/jquery-ui.min.js";
      document.head.appendChild(juiScript);

      // --- Text Auto-Fit Plugin ---------------------------------------
      jQuery.fn.textfill = function(options) {
        var fontSize = options.maxFontSize;
        var ourText = jQuery("span:visible:first", this);
        var maxWidth = jQuery(this).width();
        var maxHeight = options.maxLineHeight;
        do {
          ourText.css("font-size", fontSize);
          fontSize--;
        } while (
          (ourText.height() > maxHeight || ourText.width() > maxWidth) &&
          fontSize >= options.minFontSize
        );
        return this;
      };

      // --- State ------------------------------------------------------
      var responseTimer = 0;
      var previewLoaded = false;
      var lineError = false;
      var previewImageSource = "";

      // --- Fetch Template from Backend --------------------------------
      jQuery.getJSON(
        ldMainUrl + "ytimes-label-designer-2023.php?c=1&lid=" + labelDesignerId + "&jsonp=?",
        function(data) {
          if (data.indexOf("ERROR") >= 0 || data.indexOf("NOTEMPLATE") >= 0) return;
          clearTimeout(responseTimer);

          $mount.append(data);

          var usedTemplateId = jQuery("#labelElements").attr("data-tid");

          // --- Yes/No Engraving Toggle ------------------------------
          jQuery("div.startLinks input[type=radio]").on("change", function() {
            jQuery("#labelOptionsMsg").html("");
            var showBox = jQuery("div.startLinks input[type=radio]:checked").attr("id").toString();

            if (showBox === "ytimesLDNo") {
              jQuery("#labelElements").slideUp().attr("aria-expanded", "false");
              jQuery("#ld-preview-float").hide();
              jQuery("#ld-add2cartOverlay").remove();
              $addToCartBtn.removeClass("ld-inactive");
              jQuery("#proofCheck").css("display", "none");
              // jQuery("html,body").css("overflow-x", "unset");
            } else {
              // jQuery("html,body").css("overflow-x", "hidden");
              // Create proof checkbox if not provided by PHP template
              if (jQuery("#proofCheck").length === 0) {
                jQuery("#labelElements").append(
                  '<div id="proofCheck">' +
                    '<input type="checkbox" id="proofCheckbox">' +
                    '<label for="proofCheckbox">I have reviewed and approve the proof shown above.</label>' +
                  '</div>'
                );
              }
              jQuery("#proofCheck").css("display", "flex");
              $addToCartBtn.addClass("ld-inactive");

              // Add overlay to block add-to-cart until proof is confirmed
              if (jQuery("#ld-add2cartOverlay").length === 0) {
                var $btnWrapper = $addToCartBtn.parent();
                $btnWrapper.css("position", "relative");
                $btnWrapper.append('<div id="ld-add2cartOverlay"></div>');
                jQuery("#ld-add2cartOverlay").css({
                  position: "absolute",
                  top: 0, left: 0,
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                  zIndex: 10
                });
                jQuery("#ld-add2cartOverlay").click(function(e) {
                  e.stopPropagation();
                  e.preventDefault();
                  if (jQuery("#proofCheckbox").is(":checked")) {
                    jQuery("#previewLabel").click();
                  } else {
                    alertPop("Please check the proof checkbox");
                  }
                });
              }

              // Show text line areas
              jQuery("#labelElements div.textLine[data-abox=1]").show();
              jQuery("#labelElements div.textLine[data-abox=2]").show();

              var titleAB1 = jQuery("#textLines .head .label").data("ab1name");
              if (jQuery("#inLabelAB1").length === 0) {
                jQuery("#labelElements div.textLine[data-abox=1]:first").before(
                  '<div class="inLabel" id="inLabelAB1">' + titleAB1 + " Engraving</div>"
                );
              }

              var titleAB2 = jQuery("#textLines .head .label").data("ab2name");
              if (titleAB2 !== "" && jQuery("#inLabelAB2").length === 0) {
                jQuery("#labelElements div.textLine[data-abox=2]:first").before("<hr>");
                jQuery("#labelElements div.textLine[data-abox=2]:first").before(
                  '<div class="inLabel" id="inLabelAB2">' + titleAB2 + " Engraving</div>"
                );
              }

              // --- Art Upload Elements ----------------------------
              var artElems = jQuery(
                '<div class="artElems">' +
                  '<span class="title">Have a custom logo or symbol you\'d like to use?</span>' +
                  '<span class="iconPop"><i class="far fa-question-circle"></i></span>' +
                  '<span class="lowQty">LOW <font color="#bf0f11">5 Piece min</font> qty required</span>' +
                "</div>"
              );
              artElems.append(
                '<div class="choice">' +
                  '<span class="radio"><i class="far fa-check-circle"></i><i class="far fa-circle"></i></span>' +
                  '<span class="icon"><i class="fas fa-upload"></i></span>' +
                  '<span class="label">Upload logo now</span>' +
                  '<form class="logoUpload" name="logoUploadAB1" action="' + ldMainUrl + 'ytimes-label-logo-upload.php" method="post" target="logoTargetAB1" enctype="multipart/form-data">' +
                    '<label class="uploadButton"><input type="file" name="logoFileAB1">Browse</label>' +
                    '<input type="hidden" name="c" value="41">' +
                  "</form>" +
                  '<span class="note">Accepted file formats: .jpg, .eps, .cdr, .pdf, .tiff</span>' +
                  '<iframe name="logoTargetAB1" id="logoTargetAB1" style="display:none;"></iframe>' +
                "</div>"
              );
              artElems.append(
                '<div class="choice">' +
                  '<span class="radio"><i class="far fa-check-circle"></i><i class="far fa-circle"></i></span>' +
                  '<span class="icon"><i class="far fa-envelope"></i></span>' +
                  '<span class="label">Send logo later</span>' +
                "</div>"
              );
              artElems.append(
                '<div class="note"><i>Proof shown here is a rough proof. We will email a final proof for logo orders before we personalize and ship your order. If you have any special requests (for example, you&apos;d like a logo and text or you&apos;d like a particular placement of your logo) please let us know in the Additional Engraving Instructions area below.</i></div>'
              );
              artElems.append(
                '<div class="linkQandA"><span class="icon"><i class="far fa-comments"></i></span><span class="label">See Questions & Answers (<div class="qaCount"></div>)</span></div>'
              );

              // --- Show shared font selector with header above both areas -
              if (jQuery("#ldEngravingDetailsHeader").length === 0) {
                jQuery("#textLinesFont").before('<div id="ldEngravingDetailsHeader">Select Engraving Details</div>');
                jQuery("#textLinesFont").show();
              }

              // --- Build Align Box 1 -----------------------------
              if (jQuery(".engTypeAB1").length === 0) {
                jQuery("#inLabelAB1").after(
                  '<div class="engType engTypeAB1">' +
                    '<span class="button"><input type="radio" name="engtypeab1" id="engtypeab1text" value="text" checked><label tabindex="0" for="engtypeab1text">Text</label></span>' +
                    '<span class="button"><input type="radio" name="engtypeab1" id="engtypeab1art" value="art"><label for="engtypeab1art" tabindex="0">Logo</label></span>' +
                    '<span class="button"><input type="radio" name="engtypeab1" id="engtypeab1none" value="blank"><label for="engtypeab1none" tabindex="0">Blank</label></span>' +
                  "</div>"
                );
                jQuery("#ytimesLabelDesigner .engType.engTypeAB1 span.button label").on("keydown", function(e) {
                  if (e.keyCode === 13 || e.keyCode === 32) { e.target.click(); e.preventDefault(); return false; }
                });
                jQuery(".engTypeAB1").after('<div id="blankFrameAB1">Your product\'s <b>' + titleAB1 + "</b> will be <b>blank.</b></div>");
                jQuery(".engTypeAB1").after('<div id="artFrameAB1"></div>');
                jQuery("#artFrameAB1").append(artElems);
                jQuery(".engTypeAB1").after('<div id="textLinesFrameAB1" class="textLinesFrameAB"></div>');
                jQuery("#textLinesFrameAB1").append(jQuery("div.textLine[data-abox='1']"));
              }

              // --- Build Align Box 2 -----------------------------
              if (jQuery("#inLabelAB2").length > 0 && jQuery(".engTypeAB2").length === 0) {
                jQuery("#inLabelAB2").after(
                  '<div class="engType engTypeAB2">' +
                    '<span class="button"><input type="radio" name="engtypeab2" id="engtypeab2text" value="text" checked><label tabindex="0" for="engtypeab2text">Text</label></span>' +
                    '<span class="button"><input type="radio" name="engtypeab2" id="engtypeab2art" value="art"><label tabindex="0" for="engtypeab2art">Logo</label></span>' +
                    '<span class="button"><input type="radio" name="engtypeab2" id="engtypeab2none" value="blank"><label tabindex="0" for="engtypeab2none">Blank</label></span>' +
                  "</div>"
                );
                jQuery("#ytimesLabelDesigner .engType.engTypeAB2 span.button label").on("keydown", function(e) {
                  if (e.keyCode === 13 || e.keyCode === 32) { e.target.click(); e.preventDefault(); return false; }
                });
                jQuery(".engTypeAB2").after('<div id="blankFrameAB2">Your product\'s <b>' + titleAB2 + "</b> will be <b>blank.</b></div>");
                jQuery(".engTypeAB2").after('<div id="artFrameAB2"></div>');
                jQuery("#artFrameAB2").append(artElems.clone());
                jQuery("#artFrameAB2 form.logoUpload").attr("name", "logoUploadAB2").attr("target", "logoTargetAB2");
                jQuery("#artFrameAB2 form.logoUpload input[type='file']").attr("name", "logoFileAB2");
                jQuery("#artFrameAB2 #logoTargetAB1").attr("name", "logoTargetAB2").prop("id", "logoTargetAB2");
                jQuery(".engTypeAB2").after('<div id="textLinesFrameAB2" class="textLinesFrameAB"></div>');
                jQuery("#textLinesFrameAB2").append(jQuery("div.textLine[data-abox='2']"));
              }

              // Show label designer
              jQuery("#labelElements").slideDown().attr("aria-expanded", "true");

              // Re-check isLogoReady in case the PHP template set window.isLogoReady
              // after it was injected into the DOM
              if (typeof window.isLogoReady !== "undefined") {
                isLogoReady = !!window.isLogoReady;
              }

              // Hide logo option if not enough text lines or logo not ready
              var ab1Lines = jQuery("#textLinesFrameAB1 .textLine").length;
              var ab2Lines = jQuery("#textLinesFrameAB2 .textLine").length;
              console.log("[LabelDesigner] Logo check — isLogoReady:", isLogoReady, "AB1 lines:", ab1Lines, "AB2 lines:", ab2Lines);

              if (!isLogoReady || ab1Lines < 2) {
                jQuery("#engtypeab1art").closest("span.button").addClass("ld-hidden");
              }
              if (!isLogoReady || ab2Lines < 2) {
                jQuery("#engtypeab2art").closest("span.button").addClass("ld-hidden");
              }

              // --- Build Preview Box -----------------------------
              jQuery("#labelPreviewBox").remove();

              // Build the preview box inside the engraving panel. Its final
              // on-screen placement is set by positionLabelPreview() once the
              // align boxes are added — floating beside the engraving controls
              // on desktop, inline below the controls on mobile.
              jQuery("#labelElements").append('<div id="labelPreviewBox"></div>');
              
              var labPrevImage = jQuery("#textLinesFrame").data("pimage").split(",");
              jQuery("#labelPreviewBox").append('<div id="labelPreviewImageFrame"></div>');
              jQuery("#labelPreviewImageFrame").append(
                '<div id="labelPreviewImage" style="width:' + labPrevImage[1] + "px;height:" + labPrevImage[2] + 'px;">' +
                  '<img src="' + ldMainUrl + "templateImages/" + labPrevImage[0] + '">' +
                "</div>"
              );

              // --- Align Boxes on Preview ------------------------
              var alignboxes = "";
              if (jQuery("#textLinesFrame").data("alignbox1") !== "") {
                var abtb1Val = jQuery("#textLinesFrame").data("alignbox1").split(",");
                alignboxes += '<div id="alignTextBox1" style="position:absolute;top:' + parseInt(abtb1Val[1]) + "px;left:" + parseInt(abtb1Val[0]) + "px;width:" + abtb1Val[2] + "px;height:" + abtb1Val[3] + 'px;"></div>';
              }
              if (jQuery("#textLinesFrame").data("alignbox2") !== "") {
                var abtb2Val = jQuery("#textLinesFrame").data("alignbox2").split(",");
                alignboxes += '<div id="alignTextBox2" style="position:absolute;top:' + parseInt(abtb2Val[1]) + "px;left:" + parseInt(abtb2Val[0]) + "px;width:" + abtb2Val[2] + "px;height:" + abtb2Val[3] + 'px;"></div>';
              }
              jQuery("#labelPreviewImageFrame").append(alignboxes);

              positionLabelPreview();
              // The engraving panel slides open over ~400ms — reposition once it
              // settles so the preview lands level with the first text input.
              setTimeout(positionLabelPreview, 450);

              setTimeout(function() { resizeMobileFonts(); }, 1000);
            }
          });

          // --- Engraving Type Switching (AB1) -----------------------
          jQuery("#ytimesLabelDesigner").on("click", 'div.engType input[name="engtypeab1"]', function() {
            var val = jQuery('div.engType input[name="engtypeab1"]:checked').val();
            switch (val) {
              case "text":
                jQuery("#textLinesFrameAB1").show();
                jQuery("#artFrameAB1").hide();
                clearLogo(jQuery("#artFrameAB1"));
                jQuery("#blankFrameAB1").hide();
                break;
              case "art":
                jQuery("#artFrameAB1").show();
                jQuery("#textLinesFrameAB1").hide();
                jQuery('#textLinesFrameAB1 .textLine input[type="text"]').val("").trigger("change");
                jQuery("#blankFrameAB1").hide();
                break;
              case "blank":
                jQuery("#blankFrameAB1").show();
                jQuery("#textLinesFrameAB1").hide();
                jQuery('#textLinesFrameAB1 .textLine input[type="text"]').val("").trigger("change");
                jQuery("#artFrameAB1").hide();
                clearLogo(jQuery("#artFrameAB1"));
                break;
            }
          });

          // --- Engraving Type Switching (AB2) -----------------------
          jQuery("#ytimesLabelDesigner").on("click", 'div.engType input[name="engtypeab2"]', function() {
            var val = jQuery('div.engType input[name="engtypeab2"]:checked').val();
            switch (val) {
              case "text":
                jQuery("#textLinesFrameAB2").show();
                jQuery("#artFrameAB2").hide();
                clearLogo(jQuery("#artFrameAB2"));
                jQuery("#blankFrameAB2").hide();
                break;
              case "art":
                jQuery("#artFrameAB2").show();
                jQuery("#textLinesFrameAB2").hide();
                jQuery('#textLinesFrameAB2 .textLine input[type="text"]').val("").trigger("change");
                jQuery("#blankFrameAB2").hide();
                // Logo orders require 5-piece minimum
                if ($quantityInput.length && parseInt($quantityInput.val()) < 5) {
                  $quantityInput.val(5);
                }
                break;
              case "blank":
                jQuery("#blankFrameAB2").show();
                jQuery("#textLinesFrameAB2").hide();
                jQuery('#textLinesFrameAB2 .textLine input[type="text"]').val("").trigger("change");
                jQuery("#artFrameAB2").hide();
                clearLogo(jQuery("#artFrameAB2"));
                break;
            }
          });

          // --- Logo Upload Choice Selection -------------------------
          jQuery("#ytimesLabelDesigner").on("click", "#artFrameAB1 .choice", function() {
            jQuery("#artFrameAB1 .choice").removeClass("selected");
            jQuery(this).addClass("selected");
          });
          jQuery("#ytimesLabelDesigner").on("click", "#artFrameAB2 .choice", function() {
            jQuery("#artFrameAB2 .choice").removeClass("selected");
            jQuery(this).addClass("selected");
          });

          // --- Logo File Upload Handler -----------------------------
          jQuery("#ytimesLabelDesigner").on("change", 'form.logoUpload input[type="file"]', function() {
            var tform = jQuery(this).closest("form.logoUpload");
            tform.parent().find("span.icon.remove").remove();
            tform.parent().find("span.icon.green").remove();
            tform.next("span.note").text("");
            tform.next("span.note").after('<span class="icon gray"><i class="fas fa-spinner fa-spin"></i></span>');
            tform.submit();
          });
          jQuery("#ytimesLabelDesigner").on("submit", "form.logoUpload", function() {
            jQuery(this).find('input[name="abox"]').remove();
            if (jQuery(this).attr("name") === "logoUploadAB1") {
              jQuery(this).append('<input type="hidden" name="abox" value="1">');
            } else {
              jQuery(this).append('<input type="hidden" name="abox" value="2">');
            }
          });
          jQuery("#ytimesLabelDesigner").on("click", "#artFrameAB1 span.remove", function() { clearLogo(jQuery("#artFrameAB1")); });
          jQuery("#ytimesLabelDesigner").on("click", "#artFrameAB2 span.remove", function() { clearLogo(jQuery("#artFrameAB2")); });

          // Font sync — shared #textlinefont handles both areas.
          // The existing change handler on #textlinefont (further below) re-renders text.
          jQuery("#ytimesLabelDesigner span.button label").on("keydown", function(e) {
            if (e.keyCode === 13 || e.keyCode === 32) { e.target.click(); e.preventDefault(); return false; }
          });

          // --- Logo Upload PostMessage Handler ----------------------
          function uploadMsg(e) {
            if (e.origin === "https://labeldesigner.executivegiftsblog.com" && typeof e.data !== "undefined") {
              var dt = JSON.parse(e.data);
              var tform = dt.abox === "1"
                ? jQuery('form.logoUpload[name="logoUploadAB1"]')
                : jQuery('form.logoUpload[name="logoUploadAB2"]');
              var imn = dt.imgname.toLowerCase();
              tform.next("span.note").text("File: " + dt.imgname);
              tform.next("span.note").attr("data-imgurl", dt.imgurl.substring(dt.imgurl.lastIndexOf("/") + 1));
              tform.parent().find("span.icon.remove").remove();
              tform.parent().find("span.icon.gray").remove();
              tform.parent().find("span.icon.green").remove();
              tform.next("span.note").after('<span class="icon remove"><i class="fas fa-times"></i> remove</span>');
              tform.next("span.note").after('<span class="icon green"><i class="fas fa-check"></i></span>');

              var primg = jQuery('<img src="' + ldMainUrl + 'customerLogos/default-pr-logo.png" style="display:block;max-width:100%;height:auto;max-height:100%;width:auto;margin:auto;">');
              if (imn.includes(".png") || imn.includes(".jpg") || imn.includes(".gif") || imn.includes(".jpeg") || imn.includes(".webp")) {
                primg.attr("src", dt.imgurl);
              }
              if (dt.abox === "1") {
                jQuery("#alignTextBox1").empty().append(primg);
              } else {
                jQuery("#alignTextBox2").empty().append(primg);
              }
            }
          }
          window.addEventListener("message", uploadMsg, false);

          // --- Live Text Preview ------------------------------------
          jQuery("#textLinesFrame input[type='text']").on("keyup change blur", function() {
            var actTL = jQuery(this);
            if (!jQuery("#labelPreviewBox").is(":visible")) return;

            var abId = "alignTextBox" + actTL.parents(".textLine").data("abox");
            var pLineId = actTL.attr("id").replace("#", "").replace("textline", "prevline");

            if (actTL.val() !== "") {
              if (jQuery("#" + pLineId).length === 0) {
                if (jQuery("#" + abId).find("p").length === 0) {
                  jQuery("#" + abId).append('<p id="' + pLineId + '"><span></span></p>');
                } else {
                  jQuery("#" + abId + " p").each(function() {
                    var tP = jQuery(this);
                    var tPind = tP.attr("id").replace("#", "");
                    if (parseInt(pLineId.replace("prevline", "")) < parseInt(tPind.replace("prevline", ""))) {
                      tP.before('<p id="' + pLineId + '"><span></span></p>');
                    } else if (tP.is(":last-child")) {
                      tP.after('<p id="' + pLineId + '"><span></span></p>');
                    }
                  });
                }
              }

              var selectedFontFamily = jQuery("#textlinefont").find("option:selected").text();
              var selectedFontStyle = "unset";
              if (selectedFontFamily === "Times Italic") {
                selectedFontFamily = "Times New Roman";
                selectedFontStyle = "italic";
              }
              jQuery("#" + pLineId + " span").text(actTL.val()).css({ "font-family": selectedFontFamily, "font-style": selectedFontStyle });

              // Auto-size text
              var maxLHei = jQuery("#" + abId).height() / jQuery("#" + abId).find("p").length;
              jQuery("#" + abId + " p").each(function() {
                if (!jQuery(this).hasClass("sizeoverride")) {
                  jQuery(this).textfill({ maxFontSize: 70, minFontSize: 10, maxLineHeight: maxLHei });
                }
              });
              var calculatedFontSize = parseInt(jQuery("#" + pLineId + " span").css("font-size").replace("px", "")) * 0.85;
              actTL.attr("data-fontsize", parseInt(calculatedFontSize));
            } else {
              jQuery("#" + pLineId).remove();
            }
          });

          // Uncheck proof when text changes
          jQuery("#textLinesFrame input[type='text']").on("change", function() {
            if (jQuery("#proofCheckbox").is(":checked")) {
              jQuery("#proofCheckbox")[0].click();
            }
          });

          // --- Manual Font Size Override -----------------------------
          jQuery(".textElemSize select").on("change", function() {
            var pLineId = jQuery(this).attr("name").replace("#", "").replace("textline", "prevline").replace("size", "text");
            if (jQuery(this).val() === "AUTO") {
              jQuery("#" + pLineId).removeClass("sizeoverride");
              jQuery("#textLinesFrame input[type='text']").each(function() { this.dispatchEvent(new Event("change")); });
            } else {
              jQuery("#" + pLineId + " span").css("font-size", jQuery(this).val() + "px");
              jQuery("#" + pLineId).addClass("sizeoverride");
              jQuery("#" + pLineId.replace("prevline", "textline")).attr("data-fontsize", jQuery(this).val());
            }
            if (jQuery("#proofCheckbox").is(":checked")) {
              jQuery("#proofCheckbox")[0].click();
            }
          });

          // Font change triggers text re-render
          jQuery(document).on("change", "#textlinefont", function() {
            jQuery("#textLinesFrame input[type='text']").each(function() { this.dispatchEvent(new Event("change")); });
          });

          // --- Symbol / Image Selection -----------------------------
          var temptime = Date.now().toString();
          jQuery("input[name='customSymbolFile']").attr("value", temptime);

          jQuery("#ytimesLabelDesigner .symbolImage img").on("click", function() {
            jQuery("#ytimesLabelDesigner .symbolImage img").removeClass("selected");
            jQuery(this).addClass("selected");
          });
          jQuery("#symbolFrame div.symbolButton button").on("click", function() { jQuery("#imageLines").fadeIn(); });
          jQuery("#imageLines #closeButton").on("click", function() { jQuery("#imageLines").fadeOut(); });
          jQuery("#symbolClear").on("click", function() {
            jQuery("#ytimesLabelDesigner .symbolImage img").removeClass("selected");
            jQuery("input#templateImage").val("");
          });
          jQuery("#symbolPreview").on("click", function() {
            jQuery("#imageLines").fadeOut();
            jQuery("#previewLabel").click();
          });

          // --- Proof Generation & Cart Submission -------------------
          jQuery("#previewLabel").on("click", function() {
            jQuery("#ytimesModalOverlay").remove();
            jQuery("body").append(
              '<div id="ytimesModalOverlay"><div class="spinner"><img src="' + ldMainUrl + 'images/ytimes-loading-new.gif"><br><span class="msg">Finalizing personalization...</span></div></div>'
            );

            setTimeout(function() {
              // Build line data string
              var labelOpts = "";
              for (var i = 0; i < jQuery("#labelElements #textLines .textLine").length; i++) {
                var actLino = jQuery("#labelElements #textLines .textLine:eq(" + i + ")");
                labelOpts += "l" + i + "^";
                labelOpts += actLino.attr("data-line-id") + "^";
                labelOpts += jQuery("input[name*='text']", actLino).val() + "^";
                labelOpts += jQuery("select#textlinefont").val() + "^";
                labelOpts += jQuery("input[name*='text']", actLino).trigger("change").attr("data-fontsize") + "|";
              }

              // Symbol handling
              var labelSymb = "";
              if (jQuery("#templateImage").val() && jQuery("#templateImage").val() !== "") {
                var tempImgHelp = jQuery("#templateImage").val();
                var tempImgMod = tempImgHelp.substr(tempImgHelp.lastIndexOf("\\") + 1);
                labelSymb = jQuery("input[name='customSymbolFile']").val() + "-" + tempImgMod;
              } else if (jQuery("#labelElements #imageLines .symbolImage img.selected").attr("data-symb-id")) {
                labelSymb = jQuery("#labelElements #imageLines .symbolImage img.selected").attr("data-symb-id");
              }

              // Customer logos
              var clogo1 = "";
              var clogo2 = "";
              if (jQuery("#artFrameAB1 div.artElems div.choice.selected").length > 0 && jQuery("#artFrameAB1 div.artElems div.choice span.note").data("imgurl")) {
                clogo1 = jQuery("#artFrameAB1 div.artElems div.choice span.note").data("imgurl");
              }
              if (jQuery("#artFrameAB2 div.artElems div.choice.selected").length > 0 && jQuery("#artFrameAB2 div.artElems div.choice span.note").data("imgurl")) {
                clogo2 = jQuery("#artFrameAB2 div.artElems div.choice span.note").data("imgurl");
              }

              // Request proof from backend
              jQuery.getJSON(
                ldMainUrl + "ytimes-label-preview-2023.php?c=16&lid=" + labelDesignerId +
                "&lins=" + encodeURIComponent(labelOpts) +
                "&symbs=" + labelSymb +
                "&cl1=" + encodeURIComponent(clogo1) +
                "&cl2=" + encodeURIComponent(clogo2) +
                "&jsonp=?",
                function(data) {
                  if (data !== "") {
                    var dataMsg = data.split("|");
                    var imageToShow = ldMainUrl + dataMsg[0];
                    previewImageSource = imageToShow;

                    if (data.indexOf("ERROR") > -1) {
                      if (dataMsg[1].indexOf("^") > -1) {
                        var ABTitle1 = jQuery("div[data-abox='1']:first").prev().text();
                        var ABTitle2 = jQuery("div[data-abox='2']:first").prev().text();
                        dataMsg[1] = dataMsg[1].replace("^AB:1^", ABTitle1).replace("^AB:2^", ABTitle2);
                      }
                      jQuery("#ytimesModalOverlay .spinner .msg").html("<small>Error occurred during the process, please try again...</small>");
                      previewLoaded = true;
                      lineError = true;
                    } else {
                      // Success — proceed to add to cart
                      jQuery("#ytimesModalOverlay .spinner .msg").text("Adding Item(s) to Cart...");
                      previewLoaded = true;
                      jQuery("#ld-add2cartOverlay").hide();
                      // Trigger cart add
                      saveLabel();
                    }
                  }
                }
              );
            }, 500);
          });

          // --- Proof Checkbox (delegated so it works for dynamically created checkbox) --
          jQuery("#ytimesLabelDesigner").on("click", "#proofCheckbox", function() {
            if (jQuery(this).is(":checked")) {
              $addToCartBtn.removeClass("ld-inactive");
            } else {
              $addToCartBtn.addClass("ld-inactive");
            }
          });

          // --- Reorder Pre-fill -------------------------------------
          if (getUrlParam("label_id") !== null) {
            var pdpID = getUrlParam("label_id");
            var genpdpID = pdpID;	// "customlabels-" + pdpID;
            jQuery.getJSON(
              ldMainUrl + "ytimes-label-designer-get-reorder-info.php?c=pd35&lgid=" + genpdpID + "&jsonp=?",
              function(data) {
                if (data.indexOf("ERROR") < 0) {
                  jQuery('#ytimesLabelDesigner .startLinks span.button label[for="ytimesLDAB12"]').click();

				  console.log('Personalization Reorder Info:',data);

/*

Personalization Reorder Info: 
	316$|$
	woodpenset2$|$
		line1text:Peter Ekizian^	line1font:Monotype Corsiva^	line1size:AUTO|
		line2text:^line2font:Monotype Corsiva^line2size:AUTO|
		line3text:^line3font:Monotype Corsiva^line3size:AUTO|
		line4text:Peter^line4font:Monotype Corsiva^
		line4size:AUTO|$|$
*/


                  var dataInfo = data.split("$|$");
                  var pdlinesInfo = dataInfo[2].split("|");

                  for (var pdi = 0; pdi < pdlinesInfo.length; pdi++) {
                    var pdSepLineData = pdlinesInfo[pdi].split("^");
                    if (pdSepLineData[0].substr(0, 4) === "line") {
                      var pdlineID = parseInt(pdSepLineData[0].substr(4, 2));
                      var pdlineHead = pdSepLineData[0].split(":");
                      var pdlineText = pdSepLineData[0].replace(pdlineHead[0] + ":", "");
                      jQuery("#labelElements #textLinesFrame input[name=textline" + pdlineID + "text]").attr("value", pdlineText).blur();
                      if (pdi === 0) {
                        var pdlineFont = pdSepLineData[1].split(":");
                        //jQuery("#textLinesFont select[name=textlinefont]").val(pdlineFont[1]).trigger("change");
						jQuery("#textLinesFont select[name=textlinefont] option")
							.filter(function() {
								return jQuery(this).text().trim() === pdlineFont[1];
							})
							.prop("selected", true)
							.parent()
							.trigger("change");
                      }
                      var pdlineSize = pdSepLineData[2].split(":");
                      jQuery("#labelElements #textLinesFrame select[name=textline" + pdlineID + "size]").val(pdlineSize[1]).trigger("change");
                    } else if (pdSepLineData[0].substr(0, 4) === "symb") {
                      var pdimgData = pdSepLineData[0].split(":");
                      if (pdimgData.length > 2) {
                        jQuery("#imageLines .symbolImage img[data-symb-id='" + pdimgData[1] + "']").addClass("selected");
                      } else {
                        jQuery("input#templateImage").before(
                          '<span id="customImgDispatch"><label>Custom Image: </label><input name="customuploaded" type="text" value="' + pdimgData[1] + '"></span>'
                        );
                      }
                      jQuery("#labelElements .textLine[data-hidews='1'] input").attr("disabled", true);
                      jQuery("#labelElements .textLine[data-hidews='1'] select").attr("disabled", true);
                    }
                  }
                }
              }
            );
          }
        }
      ).fail(function() {
        console.warn("[LabelDesigner] Cannot access customization server.");
      });

      responseTimer = setTimeout(function() {
        // Timeout fallback if backend doesn't respond
        console.warn("[LabelDesigner] Backend response timeout.");
      }, 5000);

      // ---------------------------------------------------------------
      // saveLabel — Generates label on backend and adds to Shopify cart
      // ---------------------------------------------------------------
      function saveLabel() {
        var hasEngraving = jQuery("div.startLinks input[type=radio]:checked").attr("id") !== "ytimesLDNO";
        var hasContent = jQuery("#labelElements .textLine input").filter(function() { return jQuery(this).val(); }).length > 0;
        var hasLogo = jQuery("#labelElements .artElems span.note").text() !== "" && jQuery("#labelElements .artElems .choice").hasClass("selected");

        if (!hasEngraving || (!hasContent && !hasLogo)) {
          // No personalization — add to cart normally
          addToShopifyCart({});
          return;
        }

        // Check if both align boxes are blank
        if (jQuery("div.engType").length > 0 &&
            jQuery('input[name="engtypeab1"]:checked').val() === "blank" &&
            jQuery('input[name="engtypeab2"]:checked').val() === "blank") {
          addToShopifyCart({});
          return;
        }

        // Get unique label ID from backend
        var labelGenerateId = "";
        jQuery.getJSON(ldMainUrl + "ytimes-cmm-get-new-id.php?c=31&jsonp=?", function(data) {
          if (data !== "ERROR") {
            labelGenerateId = "customlabels-" + data;
          } else {
            labelGenerateId = "customlabels-" + Date.now().toString();
          }
        });

        var waitCount = 0;
        var waitForLabel = setInterval(function() {
          if (labelGenerateId !== "" || waitCount > 6) {
            clearInterval(waitForLabel);
            if (labelGenerateId === "") {
              labelGenerateId = "customlabels-" + Date.now().toString();
            }

            var usedTemplateId = jQuery("#labelElements").attr("data-tid");

            // Handle logo-as-text-line notes
            if (jQuery(".engType").length > 0) {
              if (jQuery("#artFrameAB1").is(":visible") && jQuery("#artFrameAB1 .choice.selected").length > 0) {
                var artSel = jQuery("#artFrameAB1 .choice.selected");
                if (artSel.find("form.logoUpload").length > 0) {
                  jQuery('#textLinesFrameAB1 .textLine:first input[type="text"]').val(
                    "NOTE: Uploaded logo file " + ldMainUrl + "customerLogos/" + artSel.find(".note[data-imgurl]").data("imgurl")
                  );
                } else {
                  jQuery('#textLinesFrameAB1 .textLine:first input[type="text"]').val("NOTE: Send logo file later");
                }
              }
              if (jQuery("#artFrameAB2").is(":visible") && jQuery("#artFrameAB2 .choice.selected").length > 0) {
                var artSel2 = jQuery("#artFrameAB2 .choice.selected");
                if (artSel2.find("form.logoUpload").length > 0) {
                  jQuery('#textLinesFrameAB2 .textLine:first input[type="text"]').val(
                    "NOTE: Uploaded logo file " + ldMainUrl + "customerLogos/" + artSel2.find(".note[data-imgurl]").data("imgurl")
                  );
                } else {
                  jQuery('#textLinesFrameAB2 .textLine:first input[type="text"]').val("NOTE: Send logo file later");
                }
              }
            }

            // --- Submit label to PHP backend via iframe ----------
            jQuery("#submitLabelFrame").remove();
            jQuery("#submitLabelForm").remove();
            jQuery("body").append('<iframe id="submitLabelFrame" name="submitLabelFrame" src="" style="display:none;"></iframe>');
            jQuery("body").append('<form method="post" action="' + ldMainUrl + 'ytimes-label-generate.php" target="submitLabelFrame" id="submitLabelForm" style="display:none;" enctype="application/x-www-form-urlencoded"></form>');
            jQuery("#submitLabelForm").append('<input type="hidden" name="c" value="17">');
            jQuery("#submitLabelForm").append('<input type="hidden" name="lid" value="' + usedTemplateId + '">');
            jQuery("#submitLabelForm").append('<input type="hidden" name="yid" value="' + labelDesignerId + '">');
            jQuery("#submitLabelForm").append('<input type="hidden" name="labelname" value="' + labelGenerateId + '">');
            jQuery("#submitLabelForm").append('<input type="hidden" name="linecount" value="' + jQuery("#labelElements .textLine").length + '">');

            // Build line item properties for Shopify cart
            var properties = {
              "Label_ID": labelGenerateId,
              "Engraving Font": jQuery("#labelElements select#textlinefont option:selected").text(),
              "_label_preview": previewImageSource // underscore = hidden from customer
            };

            // Add text lines to both the PHP form and Shopify properties
            for (var i = 1; i <= jQuery("#labelElements .textLine").length; i++) {
              var lineVal = jQuery("#labelElements .textLine input[name='textline" + i + "text']").val() || "";
              var lineSafe = lineVal.replace(/[']/g, "&apos;").replace(/[°]/g, "&deg;");

              jQuery("#submitLabelForm").append('<input type="hidden" name="line' + i + 'text" value="' + encodeURI(lineSafe) + '">');
              jQuery("#submitLabelForm").append('<input type="hidden" name="line' + i + 'size" value="' + (jQuery("#labelElements .textLine select[name='textline" + i + "size']").val() || "AUTO") + '">');

              if (lineVal !== "") {
                var egLineLabel = jQuery("#labelElements .textLine input[name='textline" + i + "text']").closest(".textLinesFrameAB").prevAll(".inLabel:first").text();
                if (egLineLabel) egLineLabel += " ";
                var lineDef = jQuery("#labelElements .textLine input[name='textline" + i + "text']").data("default");
                var propName = lineDef || (egLineLabel + "Line " + i);
                properties[propName] = lineVal;

                var sizeVal = jQuery("#labelElements .textLine select[name='textline" + i + "size']").val() || "AUTO";
                properties[propName + " Size"] = sizeVal;
              }
            }

            // Font to PHP form
            jQuery("#submitLabelForm").append('<input type="hidden" name="linefont" value="' + jQuery("#labelElements select#textlinefont option:selected").text() + '">');

            // Symbol handling
            if (jQuery("#templateImage").val() && jQuery("#templateImage").length > 0) {
              var symVal = jQuery("input[name='customSymbolFile']").val() + "-" + jQuery("#labelElements #templateImage").val().replace("C:\\fakepath\\", "");
              jQuery("#submitLabelForm").append('<input type="hidden" name="customlogofile" value="' + symVal + '">');
              properties["Engraving Symbol"] = symVal;
            } else if (jQuery("#labelElements #imageLines .symbolImage img.selected").attr("data-symb-id") &&
                       jQuery("#labelElements #imageLines .symbolImage img.selected").attr("data-symb-id") !== "1") {
              var symbId = jQuery("#labelElements #imageLines .symbolImage img.selected").attr("data-symb-id");
              jQuery("#submitLabelForm").append('<input type="hidden" name="logoid" value="' + symbId + '">');
              properties["Engraving Symbol"] = jQuery("#labelElements #imageLines .symbolImage img.selected").attr("data-symb-name") + " (" + symbId + ")";
            }

            // Engraving message
            if (jQuery("#labelElements #labelMessage").val()) {
              properties["Engraving Message"] = jQuery("#labelElements #labelMessage").val();
            }

            // Preview image
            jQuery("#submitLabelForm").append('<input type="hidden" name="previewimage" value="' + previewImageSource + '">');

            // Submit label to PHP backend, then add to Shopify cart
            // Using a short delay instead of the original blocking stall()
            setTimeout(function() {
              jQuery("#submitLabelForm").submit();

              // Wait for PHP backend to process, then verify and add to cart
              setTimeout(function() {
                jQuery.getJSON(
                  ldMainUrl + "ytimes-label-generate-check.php?c=18&lgid=" + labelGenerateId + "&jsonp=?",
                  function() {
                    jQuery("#labelOptionsMsg").remove();
                    jQuery("#ytimesLabelDesigner").append('<p id="labelOptionsMsg">Personalization options added to the item!</p>');
                    addToShopifyCart(properties);
                  }
                );
              }, 2000);
            }, 500);
          }
          waitCount++;
        }, 500);
      }

      // ---------------------------------------------------------------
      // addToShopifyCart — Uses Shopify AJAX Cart API
      // ---------------------------------------------------------------
      function addToShopifyCart(properties) {
        // Get the current variant ID (may have changed via variant picker)
        var variantId = $productForm.find('input[name="id"]').val() || shopifyVariantId;
        var quantity = parseInt($quantityInput.val()) || 1;

        var payload = {
          id: parseInt(variantId),
          quantity: quantity
        };

        // Only add properties if there are any
        if (Object.keys(properties).length > 0) {
          payload.properties = properties;
        }

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        })
        .then(function(response) {
          if (!response.ok) throw new Error("Cart add failed: " + response.status);
          return response.json();
        })
        .then(function(item) {
          // Success — dismiss modal and redirect/update cart
          jQuery("#ytimesModalOverlay").remove();
          jQuery("#ld-add2cartOverlay").show();

          // Trigger Shopify's cart update event (for themes that listen)
          document.dispatchEvent(new CustomEvent("cart:item-added", { detail: { item: item } }));

          // Redirect to cart (standard Shopify behavior)
          window.location.href = "/cart";
        })
        .catch(function(err) {
          console.error("[LabelDesigner] Cart error:", err);
          jQuery("#ytimesModalOverlay").remove();
          alertPop("There was an error adding the item to your cart. Please try again.");
        });
      }

      // --- Route add-to-cart through our flow while engraving is on ---
      // The overlay alone can't be trusted: it sits inside the inline
      // <add-to-cart-component>, where Firefox and Safari give it zero size,
      // and it never blocked keyboard activation. Without this, the button
      // runs Horizon's native add and the item lands in the cart with no
      // personalization. Listen on window in the capture phase so we run
      // before Horizon's document-level capture handlers.
      // When "No" is selected the overlay is removed and native add proceeds.
      function interceptAddToCart(e) {
        var $overlay = jQuery("#ld-add2cartOverlay");
        if ($overlay.length === 0) return;
        if (e.type === "click" && jQuery(e.target).closest($addToCartBtn).length === 0) return;
        if (e.type === "submit" && e.target !== $productForm[0]) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Overlay is hidden while a personalized add is already in progress
        if ($overlay.css("display") === "none") return;
        $overlay.trigger("click");
      }
      window.addEventListener("click", interceptAddToCart, true);
      window.addEventListener("submit", interceptAddToCart, true);

    }); // end document.ready
  }); // end ensureJQuery

  // -----------------------------------------------------------------------
  // Utility Functions (global scope, same as original)
  // -----------------------------------------------------------------------

  function clearLogo(elem) {
    elem.find("form.logoUpload")[0].reset();
    if (elem.attr("id") === "artFrameAB1") {
      jQuery("#alignTextBox1 img").remove();
    } else {
      jQuery("#alignTextBox2 img").remove();
    }
    elem.find(".choice").removeClass("selected");
    elem.find(".choice span.green").remove();
    elem.find(".choice span.remove").remove();
    elem.find(".choice span.note").text("Accepted file formats: .jpg, .eps, .cdr, .pdf, .tiff");
  }

  function getUrlParam(field, url) {
    var href = url ? url : window.location.href;
    var reg = new RegExp("[?&]" + field + "=([^&#]*)", "i");
    var string = reg.exec(href);
    return string ? string[1] : null;
  }

  function alertPop(ptext) {
    jQuery("#ytimesModalOverlay").remove();
    jQuery("#ytimesModalContainer").remove();
    jQuery("body").append('<div id="ytimesModalOverlay"><div id="ytimesModalContainer"></div></div>');
    jQuery("#ytimesModalContainer").append('<div class="close"><i class="fas fa-times-circle"></i></div>');
    jQuery("#ytimesModalContainer").append(ptext);
    jQuery("#ytimesModalContainer .close").click(function() {
      jQuery("#ytimesModalContainer").remove();
      jQuery("#ytimesModalOverlay").remove();
    });
  }

  function surePop(ptext) {
    jQuery("#ytimesModalOverlay").remove();
    jQuery("#ytimesModalContainer").remove();
    jQuery("body").append('<div id="ytimesModalOverlay"></div>');
    jQuery("body").append('<div id="ytimesModalContainer"></div>');
    jQuery("#ytimesModalContainer").css({
      position: "fixed",
      top: "50%", left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 100001
    });
    jQuery("#ytimesModalContainer").append('<div class="question" style="padding:25px 0px 30px;">' + ptext + "</div>");
    jQuery("#ytimesModalContainer").append(
      '<div class="buttons">' +
        '<img src="https://turbifycdn.com/ty/cdn/executiveengravables/ld-surepop-yes.png" class="yes">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
        '<img src="https://turbifycdn.com/ty/cdn/executiveengravables/ld-surepop-no.png" class="no">' +
      "</div>"
    );
    jQuery("#ytimesModalContainer .buttons img.yes").click(function() {
      jQuery("#ytimesModalContainer").remove();
      jQuery("#ytimesModalOverlay").remove();
    });
    jQuery("#ytimesModalContainer .buttons img.no").click(function() {
      jQuery("#ytimesModalContainer").remove();
      jQuery("#ytimesModalOverlay").remove();
      // Submit normally without engraving
      window.location.href = "/cart";
    });
  }

  // --- Preview Box Placement -----------------------------------------------
  // The engraving preview moves depending on the viewport:
  //   • Desktop: floats over the product image, to the left of the engraving
  //     controls, and stays in view (position:fixed) while the customer scrolls.
  //   • Mobile: sits inline, directly below the engraving choices and above the
  //     proof checkbox (whose label reads "...the proof shown above").
  var LD_DESKTOP_BREAKPOINT = 750; // px — matches the Horizon theme's grid breakpoint
  var LD_PREVIEW_GAP = 32;         // px — horizontal gap between preview and controls
  var LD_HEADER_CLEARANCE = 96;    // px — keep the preview clear of the sticky header
  var LD_CONTROLS_OFFSET = 120;    // px — drop below the controls when a product has no text input
  var LD_VIEWPORT_MARGIN = 24;     // px — breathing room so the whole box stays on screen

  // Compute the desktop preview's fixed `top` (a viewport offset). The preview
  // behaves like a sticky element with BOTH a top and a bottom boundary:
  //   • Start level with the first engraving text input — a bit lower than the
  //     controls — falling back to LD_CONTROLS_OFFSET below the controls for
  //     products that have no text input.
  //   • Never rise above the sticky header (LD_HEADER_CLEARANCE).
  //   • Never run off the bottom of the viewport: if the anchor sits too low,
  //     the box is pulled up so it stays fully visible (LD_VIEWPORT_MARGIN).
  //   • Never extend past the bottom of the engraving area: once the customer
  //     scrolls beyond the controls the preview rides off-screen with them,
  //     since they can no longer see or type into the form anyway.
  // All rects are viewport-relative, so this re-runs correctly on every scroll.
  function getDesktopPreviewTop($float, designerRect) {
    var $firstInput = jQuery("#labelElements input[type='text']").filter(":visible").first();
    var inputRect = $firstInput.length ? $firstInput[0].getBoundingClientRect() : null;
    var anchorTop = (inputRect && inputRect.height > 0)
      ? inputRect.top
      : designerRect.top + LD_CONTROLS_OFFSET;

    var floatHeight = $float[0].offsetHeight || 260;
    var stuckTop = Math.max(anchorTop, LD_HEADER_CLEARANCE);
    var bottomLimit = designerRect.bottom - floatHeight; // don't pass the engraving area's end
    // Keep the whole box on screen — never start it lower than the viewport fits.
    var viewportLimit = Math.max(window.innerHeight - floatHeight - LD_VIEWPORT_MARGIN, LD_HEADER_CLEARANCE);
    return Math.min(stuckTop, bottomLimit, viewportLimit);
  }

  // Update only the float's vertical position — cheap enough to run on scroll.
  function syncDesktopPreviewTop() {
    var $float = jQuery("#ld-preview-float");
    var $designer = jQuery("#ytimesLabelDesigner");
    if ($float.length === 0 || $float.is(":hidden") || $designer.length === 0) return;
    $float[0].style.top = getDesktopPreviewTop($float, $designer[0].getBoundingClientRect()) + "px";
  }

  window.positionLabelPreview = function() {
    var $box = jQuery("#labelPreviewBox");
    if ($box.length === 0) return;

    var isDesktop = window.matchMedia("(min-width: " + LD_DESKTOP_BREAKPOINT + "px)").matches;
    var $designer = jQuery("#ytimesLabelDesigner");

    if (isDesktop && $designer.length) {
      // Lift the preview into a fixed-position float wrapper on <body>. The
      // wrapper carries the .ytimesLabelDesigner class so the namespaced
      // stylesheet still styles the preview box inside it.
      var $float = jQuery("#ld-preview-float");
      if ($float.length === 0) {
        $float = jQuery('<div id="ld-preview-float" class="ytimesLabelDesigner"></div>');
        jQuery("body").append($float);
      }
      $float.append($box).show();

      var rect = $designer[0].getBoundingClientRect();
      // Right edge sits LD_PREVIEW_GAP px left of the engraving controls column.
      $float[0].style.right = Math.max(window.innerWidth - rect.left + LD_PREVIEW_GAP, 16) + "px";
      $float[0].style.top = getDesktopPreviewTop($float, rect) + "px";
    } else {
      // Mobile: inline, just above the proof checkbox so "proof shown above" holds.
      jQuery("#ld-preview-float").remove();
      var $proof = jQuery("#proofCheck");
      if ($proof.length) {
        $box.insertBefore($proof);
      } else {
        jQuery("#labelElements").append($box);
      }
    }
  };

  window.resizeMobileFonts = function() {
    var previewImg = document.querySelector("#labelPreviewImage img");
    if (!previewImg) return;

    if (window.innerWidth < previewImg.naturalWidth + 20) {
      var abBox1 = document.querySelector("#alignTextBox1");
      var abBox2 = document.querySelector("#alignTextBox2");
      if (!abBox1 || !abBox2) return;

      var ow = previewImg.naturalWidth;
      var scaleX = previewImg.clientWidth / ow;
      var scaleY = previewImg.clientHeight / previewImg.naturalHeight;

      // Scale align box 1
      var ab1ow = abBox1.dataset.ow || abBox1.clientWidth;
      var ab1oh = abBox1.dataset.oh || abBox1.clientHeight;
      var ab1opx = abBox1.dataset.ol || abBox1.offsetLeft;
      var ab1opy = abBox1.dataset.ot || abBox1.offsetTop;
      if (!abBox1.dataset.ow) {
        abBox1.dataset.ow = ab1ow; abBox1.dataset.oh = ab1oh;
        abBox1.dataset.ol = ab1opx; abBox1.dataset.ot = ab1opy;
      }
      abBox1.style.width = (ab1ow * scaleX) + "px";
      abBox1.style.height = (ab1oh * scaleY) + "px";
      abBox1.style.top = (ab1opy * scaleX) + "px";
      abBox1.style.left = (ab1opx * scaleY) + "px";

      // Scale align box 2
      var ab2ow = abBox2.dataset.ow || abBox2.clientWidth;
      var ab2oh = abBox2.dataset.oh || abBox2.clientHeight;
      var ab2opx = abBox2.dataset.ol || abBox2.offsetLeft;
      var ab2opy = abBox2.dataset.ot || abBox2.offsetTop;
      if (!abBox2.dataset.ow) {
        abBox2.dataset.ow = ab2ow; abBox2.dataset.oh = ab2oh;
        abBox2.dataset.ol = ab2opx; abBox2.dataset.ot = ab2opy;
      }
      abBox2.style.width = (ab2ow * scaleX) + "px";
      abBox2.style.height = (ab2oh * scaleY) + "px";
      abBox2.style.top = (ab2opy * scaleX) + "px";
      abBox2.style.left = (ab2opx * scaleY) + "px";
    }
  };

  window.addEventListener("orientationchange", resizeMobileFonts);
  window.addEventListener("resize", resizeMobileFonts);
  window.addEventListener("orientationchange", positionLabelPreview);
  window.addEventListener("resize", positionLabelPreview);

  // Keep the floating preview within its top/bottom bounds as the page scrolls
  // (rAF-throttled so it stays cheap).
  var ldScrollQueued = false;
  window.addEventListener("scroll", function() {
    if (ldScrollQueued) return;
    ldScrollQueued = true;
    window.requestAnimationFrame(function() {
      ldScrollQueued = false;
      syncDesktopPreviewTop();
    });
  }, { passive: true });

})();
